var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 567 567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil-warning-1 {fill:#4D485B;fill-rule:nonzero}\n    .fil-warning {fill:#F8C300;fill-rule:nonzero}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_6"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil-warning",
    d: "M311.747 49.9137l125.468 217.323 125.469 217.323c8.94088,15.5594 3.57564,35.4233 -11.9838,44.3654 -5.11127,2.93659 -10.6903,4.32692 -16.1902,4.32219l0 0.139387 -250.936 0 -250.936 0c-18.0235,0 -32.6368,-14.6132 -32.6368,-32.6368 0,-7.03552 2.23138,-13.556 6.01847,-18.8858l123.912 -214.627 125.468 -217.323c8.94206,-15.5594 28.806,-20.9247 44.3654,-11.9838 5.17269,2.97321 9.21375,7.15719 11.9826,11.985l0.00118125 -0.00118125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil-warning-1",
    d: "M271.032 394.737l-12.1279 -171.53 0 -71.7161 49.192 0 0 71.7161 -11.451 171.53 -25.613 0zm-10.395 80.3037l0 -45.2749 45.7262 0 0 45.2749 -45.7262 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9f697db2759f85c48d9485c7ed413faf.svg";
export { ForwardRef as ReactComponent };